<div class="top-container">
  <h2>{{ overview.title }}</h2>
  <h4>{{ overview.subtitle }}</h4>
  <p>{{ overview.description }}</p>
  <div style="display: flex">
    <div class="item detail">
      @for (content of overview.content; track $index) {
        <h4>{{ content.title }}</h4>
        <ul class="tech">
          @if (content.itemList) {
            @for (item of content.itemList; track $index) {
              @if (typeof item !== 'string' && item.title) {
                <li>{{ item.title }}</li>
                <ul>
                  @for (subitem of item.sublist; track $index) {
                    <li>{{ subitem }}</li>
                  }
                </ul>
              } @else {
                <li>{{ item }}</li>
              }
            }
          }
          @if (content.tableRows) {
            <table class="basic-primary-table">
              @for (row of content.tableRows; track $index) {
                <tr>
                  @for (cell of row; track $index) {
                    <td>{{ cell }}</td>
                  }</tr>
              }
            </table>
          }
        </ul>
        <p class="notes">{{ content.notes }}</p>
      }
    </div>
    <div class="images">
    </div>
  </div>
</div>
